import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs-compat/Observable'
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
import { environment } from 'environments/environment';
@Injectable()
export class TtsServiceService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    generateAudio = (data: any): Observable<any> => {
        const url = `${environment.core}Tts/GenerateAudio`;
        return this._http.post<any>(url, data, { responseType: 'silent' as 'json'});
    }
}
